import {generateRandomId} from '@legit.health/ui';
import {BODY_PARTS_ARRAY} from '../consts';
import type {FormValues, ImageValueWithBase64Cache} from '../interfaces';

function createEmptyImageValue(): ImageValueWithBase64Cache {
  return {
    crop: null,
    file: null,
    id: generateRandomId(),
    base64: null
  };
}

export default function createInitialFormState(): FormValues {
  return Object.fromEntries(
    BODY_PARTS_ARRAY.map((key) => [key, createEmptyImageValue()])
  ) as FormValues;
}
